export default "__VITE_ASSET__BloPslTm__"